var React = require('react');

function SingleChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2_1457)","key":0},React.createElement("path",{"d":"M0.342447 8.0287L11.1581 18.3326C11.4435 18.5819 11.7004 18.665 11.9857 18.665C12.3567 18.665 12.4994 18.6096 12.7848 18.3603L23.6575 8.001C24.1142 7.58552 24.1142 6.89305 23.6575 6.44987L22.8299 5.64661C22.3733 5.23113 21.66 5.23113 21.2033 5.64661L11.9572 14.4825L2.76813 5.702C2.31154 5.28652 1.5981 5.28652 1.1415 5.702L0.342447 6.47757C-0.114151 6.89305 -0.114151 7.58552 0.342447 8.0287Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2_1457"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

SingleChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SingleChevronDown;

SingleChevronDown.default = SingleChevronDown;
